import { application } from 'lib/pages-common'
import ScrollProgressBarController from 'pages/cash-for-gold-page/scroll-progress-bar-controller'

application.register('scroll-progress-bar', ScrollProgressBarController)
